var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-layout',_vm._b({class:_vm.classes,attrs:{"tag":_vm.setTag,"href":_vm.url,"target":_vm.setTarget,"rel":_vm.setRel,"tabindex":_vm.url || _vm.handler ? 0 : undefined},nativeOn:{"click":function($event){return _vm.clickHandler()}}},'ui-layout',_vm.layoutProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }